import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { SidenavService } from 'src/app/services/sidenav.service';

@Injectable({
  providedIn: 'root'
})
export class AllowUrlGuard implements CanActivate {

  constructor(private readonly sidenavService: SidenavService) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

      let urls = this.sidenavService.urls;
      if (this.sidenavService.allUrlFind && (state.url !== "/unauthorized")  && (state.url !== "/error") && (state.url !== "/code") || urls.length !=0){
        if (this.lookActive(urls, state.url)) {
          return true;
        } else {
            return false;
        }
      } else {
        return true;
      }
  }

  private lookActive(urls: string [], route: string): boolean {
    for (let element of urls) {
      if (element == route) {
        return true
      }
    }
    return false;
  }
  
}
